import { constants } from './tooltip.constant'

import { createSelector } from '@/factory'

const getTargets = () => createSelector<NodeListOf<HTMLElement>>({ selector: constants.selector.target }, true)

export const tooltipSelectors = {
	getTargets,
}
